import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";

import ContactMe2 from "../blocks/contacts/ContactMe2";
import ContactMe from "../blocks/home/ContactMe";
import HomePortfolio from "../blocks/home/HomePortfolio";
import PageTitleHome from "../blocks/page-title/PageTitleHome";

const Home = () => {
  document.body.className = "";
  document.body.classList.add("home");

  return (
    <Fragment>
      <Helmet>
        <meta charSet="UTF-8" />
        <title>Home | Wedding City Australia</title>

        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </Helmet>

      <main id="main" className="site-main pt-0">
        <div className="content">
          <div className="clearfix">
            <PageTitleHome />

            <HomePortfolio />

            <ContactMe />

            <section id="contact-me-2" className="block spacer p-top-xl">
              <div className="wrapper">
                <ContactMe2 />
              </div>
            </section>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default Home;
